import { useContext, useEffect, useState } from "react"
import { MdMenuBook, MdRefresh } from "react-icons/md"
import { AppContext } from "../App"
import { callApi, formatDate, formatMoney, getInlineLoader } from "../Helpers"


export default function OrderOptions({ uuid }) {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  async function init() {
    setReady(false);
    await callApi('get-my-order-data', { uuid }).then((response) => {
      if (response.status === 1) {
        setData(response.data);
      } else {
        setData(null);
        appContext.tellError(response.msg || 'Could not load order');
      }
    })
    setReady(true);
  }

  async function retryPayment() {
    setLoading(true);
    await callApi('retry-order-payment', { orderUuid: uuid }).then(async (response) => {
      if (response.status === 1) {
        appContext.tellMessage(response.msg);
      } else {
        appContext.tellError(response.msg || 'Could not retry payment');
      }

      await init();
    })
    setLoading(false);
  }

  function openContent() {
    appContext.navTo({
      item: 'view',
      subItem: 'library-content',
      extraItem: data.uuid,
    })
  }

  useEffect(() => {
    init();
  }, [uuid])

  return (
    <div className="container marketplace-page-container order-viewer-container">
      {
        ready && data ?
          <>
            <div className="order-viewer-heading">
              <span className="marketplace-eyebrow text-primary">ORDER DETAILS</span>
              <h6>{data.item?.title || 'Your Mika Kenyata order'}</h6>
              <p>Review the payment information and available actions for this order.</p>
            </div>

            <div className="row g-4">
              <div className="col-12 col-lg-8">
                <div className="card order-options-card">
                  <div className="card-body">
                    <div className="d-flex align-items-center flex-wrap gap-2 mb-4">
                      <span className="library-type-badge">{data.itemType}</span>
                      <span className={`order-status-badge ${data.status}`}>{data.status}</span>
                    </div>

                    <div className="order-details-list">
                      <p><span>Item</span>{data.item?.title || 'Content is unavailable'}</p>
                      <p><span>Amount</span>TZS {formatMoney(data.amount)}</p>
                      <p><span>Payment Phone</span>{data.payPhone}</p>
                      <p><span>Payment Method</span>{data.payWith}</p>
                      <p><span>Order Date</span>{formatDate(data.dateCreated)}</p>
                      <p><span>Payment Reference</span>{data.paymentReference || 'Not available'}</p>
                      {
                        data.paymentConfirmedDate ?
                          <p><span>Confirmation Date</span>{formatDate(data.paymentConfirmedDate)}</p>
                          : ""
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-4">
                <div className="card order-options-card">
                  <div className="card-body">
                    <h6 className="section-title">Actions</h6>
                    {
                      data.status === 'pending' ?
                        <button
                          className="btn btn-primary btn-rounded w-100 order-action-button"
                          onClick={retryPayment}
                          disabled={loading}
                        >
                          {loading ? getInlineLoader() : <><MdRefresh size={21}/> Retry USSD Push</>}
                        </button>
                        : ""
                    }

                    {
                      data.status === 'paid' ?
                        <button
                          className="btn btn-primary btn-rounded w-100 order-action-button"
                          onClick={openContent}
                        >
                          <MdMenuBook size={21}/> Open Content
                        </button>
                        : ""
                    }

                    {
                      data.status === 'cancelled' ?
                        <p className="mb-0">Cancelled orders cannot retry payment.</p>
                        : ""
                    }
                  </div>
                </div>
              </div>
            </div>
          </>
          : ready ?
            <div className="marketplace-empty-state">Order was not found.</div>
            :
            <div className="mSupportLoading">{getInlineLoader()}</div>
      }
    </div>
  )
}
